function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import cn from 'classnames';
import withStyles from 'isomorphic-style-loader/withStyles';
import App from 'modules/App';
import messages from '../../messages';
import styles from './PlainLayout.pcss';
var _React_Component;
class PlainLayout extends (_React_Component = React.Component) {
    renderPageContent() {
        return /*#__PURE__*/ _jsx("div", {
            className: cn('col', styles.container),
            children: /*#__PURE__*/ _jsx("div", {
                className: styles.containerInner,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "content",
                    children: this.props.children
                })
            })
        });
    }
    render() {
        const titleMessage = this.props.metaTitleMessage ? this.props.metaTitleMessage : _object_spread({}, messages.meta.title);
        const descriptionMessage = this.props.metaDescriptionMessage ? this.props.metaDescriptionMessage : _object_spread({}, messages.meta.description);
        return /*#__PURE__*/ _jsx(App.components.LanguageProvider, {
            children: /*#__PURE__*/ _jsxs("div", {
                className: cn(styles.root, 'no-gutters'),
                children: [
                    /*#__PURE__*/ _jsx(App.components.IntlHelmet, {
                        titleMessage: titleMessage,
                        descriptionMessage: descriptionMessage
                    }),
                    this.renderPageContent()
                ]
            })
        });
    }
}
_define_property(PlainLayout, "propTypes", {
    // Explicit props
    metaTitleMessage: PropTypes.object,
    metaDescriptionMessage: PropTypes.object,
    // Implicit props
    children: PropTypes.node
});
const mapStateToProps = ()=>({});
const mapDispatchToProps = ()=>({});
const ConnectedPlainLayout = connect(mapStateToProps, mapDispatchToProps)(PlainLayout);
export default withStyles(styles)(ConnectedPlainLayout);
